export const  TipoSplitEnum  = Object.freeze({
  REGULAR: 1,
  IRREGULAR: 2
})